module.exports = __webpack_public_path__ + "components/app-store/static/s3-89f3267066e7095d7672031dbd31f61a.jpg";